import presetsJson from "../../../presets.json" with { type: "json" };
const file = presetsJson;
export const PRESETS = file.presets;
export const DENSITY_RULES = file.density_rules;
export const PRESET_NAMES = Object.keys(PRESETS);
export const DEFAULT_PRESET = "minimal-swiss";
export function getPreset(name) {
    return PRESETS[name];
}
export function isPresetName(value) {
    return PRESET_NAMES.includes(value);
}
